import 'firebase/compat/auth';
import firebase from 'firebase/compat/app';
import { FirebaseOptions } from 'firebase/app';
import * as firebaseui from 'firebaseui';
import { getStorage } from 'firebase/storage';

let firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyCZM0XQuH0X5JxILw0hxR8zOtLUtYfadYA',
  authDomain: 'getinked-dev.firebaseapp.com',
  projectId: 'getinked-dev',
  storageBucket: 'getinked-dev.appspot.com',
  messagingSenderId: '770416014343',
  appId: '1:770416014343:web:53ace47045252845e926a2',
  measurementId: '',
};

if (window.location.hostname === 'app.getporter.io') {
  firebaseConfig = {
    apiKey: 'AIzaSyDvtszDKNkPHuTfBD2b8AE7hz94BkNs98E',
    authDomain: 'bamboo-artwork-372213.firebaseapp.com',
    projectId: 'bamboo-artwork-372213',
    storageBucket: 'bamboo-artwork-372213.appspot.com',
    messagingSenderId: '874747184872',
    appId: '1:874747184872:web:9122525e354f289423ab5d',
    measurementId: 'G-3B6L7WXNH0',
  };
}

// Initialize Firebase
export const app = firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth(app);
export const storage = getStorage(app);
export const ui = new firebaseui.auth.AuthUI(auth);
